import type { TimeInputProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { ChangeEvent } from 'react'
import { Clock01Icon } from '@hugeicons/core-free-icons'
import { HugeiconsIcon } from '@hugeicons/react'
import { Input } from '@/components/ui/input'
import { InputFieldset } from '@/components/fhirEngineClinical/inputFieldset'
import { cn } from '@/lib/utils'

// FHIR time is "HH:mm:ss". The native time input works in "HH:mm" and we don't
// collect seconds, so we store ":00" and trim the seconds for display.
//
// We can't call showPicker() to open the native picker: it throws a SecurityError
// when the wrapper runs in a cross-origin iframe. Instead we stretch the native
// calendar-picker-indicator over the icon area and make it transparent, so the
// user clicks the native control directly (allowed in cross-origin iframes) while
// our branded icon shows underneath as decoration.
export default function TimeInput(props: TimeInputProps) {
  const { disabled, inputId, onBlur, onChange, onFocus, value } = props

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const time = event.target.value
    onChange(time ? `${time}:00` : null)
  }

  return (
    <InputFieldset {...props}>
      <div className='relative'>
        <Input
          className='bg-background appearance-none pr-8 [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:inset-y-0 [&::-webkit-calendar-picker-indicator]:right-0 [&::-webkit-calendar-picker-indicator]:my-auto [&::-webkit-calendar-picker-indicator]:h-full [&::-webkit-calendar-picker-indicator]:w-8 [&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:opacity-0'
          type='time'
          id={inputId}
          disabled={disabled}
          value={value ? value.slice(0, 5) : ''}
          onBlur={onBlur}
          onChange={handleChange}
          onFocus={onFocus}
        />
        <HugeiconsIcon
          icon={Clock01Icon}
          aria-hidden
          className={cn(
            'pointer-events-none absolute right-2 top-1/2 size-4 -translate-y-1/2',
            disabled && 'opacity-50'
          )}
        />
      </div>
    </InputFieldset>
  )
}
